import { Company } from './company';

export class Customer extends Company {
  company: Company = null;
  type: string = 'customer';

  constructor() {
    super();
  }
}
